class VariantRadios extends HTMLElement {
  constructor() {
    super();
    this.parser = new DOMParser();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(e) {
    this.updateOptions(e.target.value);
    this.updateMasterId(e.target.value);
    this.updateVariantDetails()

    try{
      this.fetchProductDetails(this.getSelectedVariantURL());
    }
    catch(error){
      
    }
    document.querySelector('#sunnies-flask') || document.querySelector('#pebble-flask') || document.querySelector('#sunnies-flask-test') || document.querySelector('#robo-flask') || document.querySelector('#bubble-lite-flask') || document.querySelector('#bubble-flask') ? '' : (this.redirectURL(), this.disableButton());
  }

  disableButton(){
    try{
      document.querySelector('.product-details .Product__header form button').setAttribute('disabled','');
    }catch(error){

    }
  }

  async fetchProductDetails(url) {
    const fullUrl = url /*+ '&section_id=' + section*/;
    
    fetch(fullUrl)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Network response was not ok: ${response.statusText}`);
        }
        return response.text(); // assuming the response is in text format
      })
      .then((data) => {
        // const sectionElement = document.querySelector(`#shopify-section-${section} form`);

        this.updateProductDetails(data);
        this.updateGallery(data);
        // updatePrescription(data);
        // Update the link after the fetch operation completes
        const customizeFlaskKidsBtnLink = document.querySelector('#customizeFlaskKidsBtnLink');

        const selectedInput = document.querySelector('.input-label-wrapper input:checked');
        if(selectedInput && selectedInput.dataset.redirection && selectedInput.dataset.redirection.length > 1){
          customizeFlaskKidsBtnLink ? customizeFlaskKidsBtnLink.href = `/products/robo-flask?source=sunnies-flask&${selectedInput.dataset.redirection}` : '';
        }else{
          customizeFlaskKidsBtnLink ? customizeFlaskKidsBtnLink.href = `/products/pebble-flask?source=sunnies-flask&bottle=${this.getCurrentVariantColor()}` : '';
        }
        
      })
      .catch((error) => {
        console.error('Fetch error:', error);
      });
  }

  updateGallery(data){
    const productGallery = document.querySelectorAll('.product-gallery-swipper');
    const doc = parser.parseFromString(data, 'text/html');
    const newProductGallery = doc.querySelectorAll('.product-gallery-swipper');
    productGallery.forEach((element, index) => {
      element.replaceWith(newProductGallery[index]);
    })
  
    document.querySelector('#product-gallery-container').setAttribute('data-product-sku', doc.querySelector('#product-gallery-container').getAttribute('data-product-sku'));
    loadGallerySwiper();
    initializeVTOGallerySwiper()
  }

  updateProductDetails(data){
      const doc = parser.parseFromString(data, 'text/html');
      if(!document.querySelector('#sunnies-flask') && !document.querySelector('#pebble-flask') && !document.querySelector('#sunnies-flask-test') && !document.querySelector('#robo-flask') && !document.querySelector('#bubble-lite-flask') && !document.querySelector('#bubble-flask')){
        const productDetailsHeader = document.querySelector('.product-details .Product__header form');
        const newProductDetailsHeader = doc.querySelector('.product-details .Product__header form');
        productDetailsHeader.replaceWith(newProductDetailsHeader);
      }
      else{
        const variantRadios = document.querySelector('variant-radios fieldset.swatch');
        const newvariantRadios = doc.querySelector('variant-radios fieldset.swatch');
        variantRadios.replaceWith(newvariantRadios);
      }

    const productPrice = document.querySelector('#product-price');
    const newproductPrice = doc.querySelector('#product-price');
    productPrice.replaceWith(newproductPrice);

    try {
      const optionName = document.querySelector('#option_name');
      const optionColor = document.querySelector('#option_color');
      optionName.innerText = document.querySelector('body').id.includes('flask') || document.querySelector('body').id.includes('boot') || document.querySelector('body').id.includes('bottle') || document.querySelector('body').id.includes('pebble-cap') || document.querySelector('body').id.includes('loop') ? this.getCurrentVariantSize() : this.getCurrentVariantSize() + ' | ';
      optionColor.innerText = document.querySelector('body').id.includes('flask') || document.querySelector('body').id.includes('boot') || document.querySelector('body').id.includes('bottle') || document.querySelector('body').id.includes('pebble-cap') || document.querySelector('body').id.includes('loop') ? ': ' + this.getCurrentVariantColor() ? ': ' + this.getCurrentVariantColor() : this.fallbackOption : this.getCurrentVariantColor();





    } catch (error) {
      console.error(error);
    }
    
    const productImage = document.querySelector('.desktop-product-vto-container');
    const newProductImage= doc.querySelector('.desktop-product-vto-container');
    productImage.replaceWith(newProductImage);
    
    if(document.querySelector('#sunnies-flask') || document.querySelector('#pebble-flask') || document.querySelector('#sunnies-flask-test') || document.querySelector('#robo-flask') || document.querySelector('#bubble-lite-flask') || document.querySelector('#bubble-flask')){
      document.querySelector('variant-radios fieldset.swatch input[checked]').click()
    }
    document.querySelector('body').id.includes('flask') || document.querySelector('body').id.includes('bottle') || document.querySelector('body').id.includes('pebble-cap') || document.querySelector('body').id.includes('loop') ? '' : this.sizeGuide();
  }

  sizeGuide() {
    try {
      const modal = document.getElementById("sizeGuideModal") || "";
      const triggerBtn = document.querySelector(".size-guide-modal-trigger") || "";
      const closeBtn = document.querySelector(".size-guide-modal__close") || "";

      triggerBtn.onclick = function () {
        modal.style.display = "block";
      }

      closeBtn.onclick = function () {
        modal.style.display = "none";
      }
      window.onclick = function (event) {
        if (event.target == modal) {
          modal.style.display = "none";
        }
      }
    } catch (error) {

    }


    const modal1 = $("#sizeGuideModalDynamic") || "";
    const triggerBtn1 = $(".size-guide-modal-trigger--dynamic") || "";
    const closeBtn1 = $(".size-guide-modal__close--dynamic") || "";

    triggerBtn1.on('click', function () {
      modal1.show();
    })

    closeBtn1.on('click', function () {
      modal1.hide();
    })

    $(document).on('click', function (event) {
      if (event.target.id == modal1.attr('id')) {
        modal1.hide();
      }
    })

  }

  getSelectedVariantURL(){
    const url = `${this.dataset.url}?variant=${ this.currentVariant ? this.currentVariant.id : this.fallbackOption.id}`;
    return url;
  }
  
  updateOptions(selectedVariantType) {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      const checkedRadio = Array.from(fieldset.querySelectorAll('input')).find((radio) => { 
        return radio.checked
      });
      return checkedRadio ? checkedRadio.value : null;
    });

  }

  updateMasterId(selectedVariantType) {
    const variant = this.getVariantData().find(variant => 
      JSON.stringify(variant.options) === JSON.stringify(this.options)
    ); 
    
    this.fallbackOption = this.getVariantData().find((variant) => {
      if (variant.available) {
        return variant.options.some((option) => option === this.options[1]);
      }
    }) || this.getVariantData().some((variant) => {
      return variant.options.some((option) => option === this.options[1]);
    });
       
    if (!variant) {
      if(document.querySelector('#sunnies-flask') || document.querySelector('#pebble-flask') || document.querySelector('#sunnies-flask-test') || document.querySelector('#robo-flask') || document.querySelector('#bubble-lite-flask') || document.querySelector('#bubble-flask')){
        this.currentVariant = this.fallbackOption;
      }else{
        const variants = this.getVariantData().filter(variant => 
          variant.options.some(option => option.includes(selectedVariantType))
        );

        const newVariant = variants.find(variant => 
          variant.options.some(option => option.includes([this.options[1], this.options[0]]))
        );

        this.currentVariant = newVariant || variants.find(variant => 
          variant.option2.includes(this.options[0])
        );
      }
    } else {
      this.currentVariant = variant;
      this.updateCustomizeFlaskKidsBtnLink();
    }
  }

  decodeHTMLEntities(text) {
    const textarea = document.createElement("textarea");
    textarea.innerHTML = text;
    return textarea.value;
  }

  updateVariantDetails() {
    
    if (!this.currentVariant) {
      console.warn('No current variant found. Please select a variant.');
      // Optionally, you can update the UI to inform the user
      const productVariantDetails = document.querySelector('#customProductDetails');
      if (productVariantDetails) {
        productVariantDetails.innerHTML = 'Please select a variant to see details.';
      }
      return; // Exit the function early
    }

    const productVariantDetails = document.querySelector('#customProductDetails');
    const productVariantData = document.querySelector("#variant_metafields_descriptions");

    if (productVariantData == null) {
      console.log('No product variant data found');
      return; // Exit the function early
    }

    try {
      const productVariantJsonData = JSON.parse(productVariantData.textContent || '{}');
      const productVariantId = this.currentVariant.id.toString();
      const productVariantDescVal = productVariantJsonData[productVariantId];

      if (productVariantDescVal) {
        productVariantDetails.innerHTML = this.decodeHTMLEntities(productVariantDescVal);
      } else {
        productVariantDetails.innerHTML = '';
      }
    } catch (error) {
      console.error('Failed to parse product variant data:', error);
    }
  }

  connectedCallback() {
    // Call updateCustomizeFlaskKidsBtnLink when the element is added to the DOM
    const selectedVariant = this.currentVariant || this.fallbackOption || this.getVariantData().find(variant => variant.available) || this.getVariantData().at(0);
    const customizeFlaskKidsBtnLink = document.querySelector('#customizeFlaskKidsBtnLink');
    const selectedInput = document.querySelector('.input-label-wrapper input:checked');
    if(selectedInput && selectedInput.dataset.redirection && selectedInput.dataset.redirection.length > 1){
      customizeFlaskKidsBtnLink ? customizeFlaskKidsBtnLink.href = `/products/robo-flask?source=sunnies-flask&${selectedInput.dataset.redirection}` : '';
    }else{
    customizeFlaskKidsBtnLink ? customizeFlaskKidsBtnLink.href = `/products/robo-flask?source=sunnies-flask&size=16oz&bottle=${selectedVariant.option1}` : '';
    }
  }

  updateCustomizeFlaskKidsBtnLink(){
    const customizeFlaskKidsBtnLink = document.querySelector('#customizeFlaskKidsBtnLink');
    const selectedInput = document.querySelector('.input-label-wrapper input:checked');
    if(selectedInput && selectedInput.dataset.redirection && selectedInput.dataset.redirection.length > 1){
      customizeFlaskKidsBtnLink ? customizeFlaskKidsBtnLink.href = `/products/robo-flask?source=sunnies-flask&${selectedInput.dataset.redirection}` : '';
    }else{
    customizeFlaskKidsBtnLink ? customizeFlaskKidsBtnLink.href = `/products/robo-flask?source=sunnies-flask&size=16oz&bottle=${this.getCurrentVariantColor()}` : ''; 
    }
  }

  redirectURL() {
    if (!this.currentVariant && !this.fallbackOption) return;
    // window.location.href = `${this.dataset.url}?variant=${ this.currentVariant ? this.currentVariant.id : this.fallbackOption.id}`;
    history.pushState({}, '', `${this.dataset.url}?variant=${ this.currentVariant ? this.currentVariant.id : this.fallbackOption.id}`);
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  getCurrentVariantID(){
    return this.currentVariant.id
  }

  getCurrentVariantSize(){
    return (this.currentVariant && this.currentVariant.option2) || this.fallbackOption.option2;
  }

  getCurrentVariantColor(){
      return this.currentVariant?.option1
  }


}

customElements.define('variant-radios', VariantRadios);
